import React from "react";
import styles from "./SkeletonStyles.module.css";
import { Skeleton } from "@mui/material";

function EdufinSkeleton() {
  return (
    <div className={styles.tableSkeletonWrap}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 12px",
          borderBottom: "1px solid rgb(234, 236, 240)",
          justifyContent: "space-between",
          gap: "10px",
          background: " #f9fafb",
          marginBottom: "10px",
        }}
      >
        <>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
          <div className={styles.tableSkeletonHeadItem}>
            <Skeleton
              animation="wave"
              variant="text"
              width="550px"
              height={23}
            />
          </div>
        </>
      </div>
      {/* <div className={styles.tableSkeletonBody}>
        {Array.from(new Array(4)).map((_, index) => (
          <div key={index} className={styles.tableSkeletonBodyRow}>
            <div className={styles.tableSkeletonBodyItem}>
              <Skeleton
                animation="wave"
                variant="text"
                width="15px"
                height={18}
              />
            </div>
            {Array.from(new Array(4)).map((_, index) => (
              <div key={index} className={styles.tableSkeletonBodyItem}>
                <Skeleton
                  animation="wave"
                  variant="text"
                  width="80px"
                  height={18}
                />
              </div>
            ))}
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default EdufinSkeleton;
